//项目logo和title的配置

export default {
  title: "快小帮-让你工作更效率",
  logo: "../pubilc/preview.gif",
};
